import styled from 'styled-components';
import theme from 'theme/theme';

const Legend = styled.legend`
  float: left;
  width: 100%;
  padding: 0;
  margin: 0 0 1.5rem 0;
  font-size: ${theme.fontSizes.large};
  color: ${theme.colors.primary};
`;

export default Legend;
